import React from 'react';
import { Dna, TrendingUp, BarChart3, Sprout } from 'lucide-react';
import ServiceComingSoon from './ServiceComingSoon';
import logo from '../../assets/img/brand/animal-genetics-icon.jpg';
import heroImage from '../../assets/img/brand/ankole-cattle-hero.jpg';

const AnimalGeneticsLanding: React.FC = () => {
  return (
    <ServiceComingSoon
      serviceId="animal-genetics"
      accent="#1f9d5a"
      accentDark="#146b3d"
      accentSoft="rgba(31, 157, 90, 0.16)"
      logo={logo}
      logoAlt="iGiTREE Animal Genetics"
      heroImage={heroImage}
      heroImageAlt="Ankole cattle grazing on green hills"
      kicker="Coming Soon"
      title="The Future of Livestock Genetics Is Coming"
      subtitle="Introducing iGiTREE Animal Genetics"
      description="Unlocking the genetic potential of livestock through genomics, science and data-driven intelligence."
      features={[
        {
          icon: <Dna size={24} strokeWidth={1.75} />,
          title: 'Genetic Profiling',
          description: 'Discover the genetics behind your herd.',
        },
        {
          icon: <TrendingUp size={24} strokeWidth={1.75} />,
          title: 'Smarter Breeding',
          description: 'Make informed breeding decisions.',
        },
        {
          icon: <BarChart3 size={24} strokeWidth={1.75} />,
          title: 'Livestock Productivity',
          description: 'Support better herd performance.',
        },
        {
          icon: <Sprout size={24} strokeWidth={1.75} />,
          title: 'Breed Conservation',
          description: 'Help preserve valuable indigenous genetics.',
        },
      ]}
      audienceQuestion="Are you a farmer, breeder, veterinary professional or agricultural partner?"
      audienceOptions={[
        { label: 'Farmer / Livestock Breeder', value: 'farmer' },
        { label: 'Veterinary Professional', value: 'vet' },
        { label: 'Agribusiness / Research Partner', value: 'agribusiness' },
      ]}
    />
  );
};

export default AnimalGeneticsLanding;
